<template>
    <el-dialog custom-class="new-dialog-class"  :title="title" :visible.sync="visible" @close="close" width="400px" :close-on-click-modal="false">
        <div class="dialog-box">
            <div class="dialog-block-box" >
                <el-form :model="secretData.form" :rules="rules" ref="form" size="mini" label-position="top">  
                    <el-form-item label="请输入查看密码:" prop="password">
                        <el-input v-model="secretData.form.password" type="password"  show-password clearable placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
                    </el-form-item>   
                    <div class="c909399 fs12"><i class="el-icon-info mr2"></i><span>为了安全起见，查看密钥需要验证密码</span></div>                  
                </el-form>
            </div> 
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: '查看密钥'
            },
            visible: {
                type: Boolean,
                default: false
            },
            loading:{
                type: Boolean,
                default: false,  
            }
        },
        data(){
            return{
                secretData:{
                    form:{
                        password:"",
                    }
                },
                rules:{
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            close(){
                this.secretData.form.password=""
                this.$emit('close')
            },
            sure(){
                this.$refs.form.validate(valid => {
                    if(valid){
                        this.$emit('sure', this.secretData.form)
                    }
                })
            }
        }
    }
</script>